import SampleEdit from '_modules/sample/views/SampleEdit.vue';
import SampleList from '_modules/sample/views/SampleList.vue';
import SampleByQuotationList from '_modules/sample/views/SampleByQuotationList.vue';
import Sample from './Root.vue';

export default {
  path: 'amostra/',
  component: Sample,
  name: 'admin-sample',
  redirect: '/amostra/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-sample-by-quotation-list',
      component: SampleByQuotationList,
    },
    {
      path: 'lista/:quotationId/:page',
      name: 'admin-sample-list',
      component: SampleList,
    },
    {
      path: ':sampleId',
      name: 'admin-sample-edit',
      component: SampleEdit,
    },
  ],
};
